import { initDataLayer, trackPageView } from './gtm';
import { mapLegacyEvent } from './eventMapping';

export const initGA = () => {
    // Initialiser dataLayer pour GTM
    initDataLayer();
    console.log('GTM initialized');
};

export const logPageView = () => {
    console.log("Tracking page view");
    trackPageView(window.location.pathname + window.location.hash);
};

// Fonction pour envoyer des événements personnalisés
export const logEvent = (category, action, label = null, value = null) => {
    // Mapper les anciens événements ReactGA vers les nouveaux événements GTM
    // Cette fonction s'occupe déjà d'envoyer les événements spécifiques
    mapLegacyEvent(category, action, label, value);

    // Nous ne conservons plus l'ancien format d'événement dans dataLayer
    // pour éviter les doublons d'événements
};


